
export default props => (
    404
);



// WEBPACK FOOTER //
// ./src/components/pages/NotFoundPage.jsx